/**
 * Shared formatting utilities for display values.
 */
/**
 * Formats a numeric value as standard USD currency.
 * Returns '$0.00' for null or undefined inputs.
 */
export function formatCurrency(val, currency = 'USD', locale = 'en-US') {
    if (val === null || val === undefined || isNaN(Number(val))) {
        return '$0.00';
    }
    const displayAmount = Math.abs(Number(val));
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
    }).format(displayAmount);
}
/**
 * Formats a date string or Date object into a short numerical format (MM/DD/YYYY).
 *
 * @example formatDate('2026-09-30') // "09/30/2026"
 */
export function formatShortDate(val) {
    if (!val)
        return '';
    const date = typeof val === 'string' ? new Date(val) : val;
    return date.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
    });
}
